import { Group } from "@fairfleet/geotab";
import { createFilterOptions } from "@mui/material/Autocomplete";
import { AUTOCOMPLETE_OPTION_LIMIT } from "@/constants/renderLimits";

/**
 * Autocomplete filter for group pickers: matches the name and renders at most
 * {@link AUTOCOMPLETE_OPTION_LIMIT} options, so 10,000 groups do not become 10,000 DOM nodes.
 */
export const groupFilterOptions = createFilterOptions<Group>({
  limit: AUTOCOMPLETE_OPTION_LIMIT,
  stringify: group => group.name ?? group.id,
});

